/* eslint-disable react-hooks/exhaustive-deps */
import { AppContext } from '../../../context';
import { Button } from '@goodtimeio/rain';
import { useHistory, useParams } from 'react-router-dom';
import ItineraryCalendarDisplay from '../../../pages/Confirm/components/ItineraryCalendarDisplay';
import React, { useContext, useEffect } from 'react';
import Wrapper from '../../../components/Wrapper';

export enum SuperdayRAPageType {
    INTERVIEWER = 'interviewer',
    CANDIDATE = 'candidate',
}
export interface SuperdayRAPageProps {
    type?: SuperdayRAPageType;
}

const SuperdaySignupConfirmPage: React.FC<SuperdayRAPageProps> = () => {
    const { organizationSlug, customUrl } = useParams<{ organizationSlug: string; customUrl: string }>();
    const { meetIntro, translate, linkAvailabilityData, interviewerAvailabilityData } = useContext(AppContext);
    const history = useHistory();

    useEffect(() => {
        if (!linkAvailabilityData) {
            history.push(`/i/${organizationSlug}/intro/${customUrl}`);
        }
    }, [linkAvailabilityData, organizationSlug, customUrl]);

    return (
        <Wrapper loading={meetIntro?.isLoading} message={translate('confirm:submitAndCalculatingAvailability')}>
            <div className="cardContainer">
                <div className="cardContent">
                    <h1 className="pendingTitle">{translate('confirm:thanksForSharingYourAvailability')}</h1>
                    <h3 className="itineraryTitle">{translate('confirm:availabilitySent')}</h3>

                    <p className="amountMeeting"></p>
                    <ItineraryCalendarDisplay
                        timeRanges={interviewerAvailabilityData?.data?.timeRanges ?? []}
                        primaryColor={''}
                        primaryTextColor={''}
                    />
                </div>

                <div className="cardFooter">
                    <Button
                        onClick={() => {
                            history.push(`/i/${organizationSlug}/intro/${customUrl}`);
                        }}
                        className="rescheduleButton"
                    >
                        {translate('confirm:updateAvailability')}
                    </Button>
                </div>
            </div>
        </Wrapper>
    );
};

export default SuperdaySignupConfirmPage;
